/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import ImageBW from '../../components/ImageBoundsWrapper';
import cdnPath from 'shared/utils/cdnPath';
import theme from 'shared/assets/style/theme';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { purchaseActionTriggers } from 'shared/constants/userActions';

const assets = require('./ItemAssets');

/** @typedef {import('shared/api/Constants').CurrencyPackageItemKeys} CPIK */

/** @param {CPIK} item */
export default function makeCoinItem(
  item,
  buyHandle,
  showPromoBoost = false,
  itemStyle,
  innerItemStyle,
  stackStyle,
  coinAmountStyle,
  extraStyle
) {
  const percent = showPromoBoost ? item.PROMO_BOOST_PERCENTAGE : parseInt(item.PERCENT_BOOST);
  let coinAmount = item.AMOUNT;
  if (showPromoBoost && !item.IS_SALE) {
    coinAmount = item.PROMO_BOOSTED_VALUE;
  } else if (showPromoBoost && item.IS_SALE) {
    coinAmount = item.AMOUNT_INCLUDING_SALE_AND_PROMO;
  }
  // TODO: trigger gold with some variable that likely doesn't exist at time of writing
  const variant = item.CORNER_FLAG ? 'gold' : 'purple';

  /*
   * Absolutely positioned centering calculations.
   * Result is icon positioned absolutely at the intersection of left inset and the rest of the bar.
   * * Since these are using two different units, it has to be evaluated with CSS's calc().
   */

  return (
    <ImageBW
      source={assets[variant].backing}
      ibw={assets.ibw.backing}
      manualAssetScale={3}
      style={itemStyle}
      innerStyle={innerItemStyle}
      key={item.ORDER + ''}
    >
      <ImageBW
        source={assets[variant].left}
        ibw={assets.ibw.left}
        manualAssetScale={3}
        style={{
          width: '12vmin',
          height: '100%',
          objectFit: 'stretch',
        }}
        innerStyle={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-evenly',
        }}
      >
        <div style={stackStyle}>
          <ImageBW
            source={require(asset`Star_Icon.png`)}
            ibw={require(asset`Star_Icon.ibw`)}
            style={{ height: 50, width: 30, objectFit: 'contain', alignSelf: 'center' }}
          />
          <div
            style={{
              paddingTop: '8%',
              fontSize: '0.9rem',
              color: variant === 'purple' ? theme.palette.common[1] : theme.palette.common[0],
              textAlign: 'center',
            }}
          >
            {item.BONUS_LOYALTY_AMOUNT}
          </div>
        </div>
      </ImageBW>
      <ImageBW
        source={assets[variant].triangle}
        ibw={assets.ibw.triangle}
        manualAssetScale={3}
        style={{
          width: '3vmin',
          height: '100%',
          objectFit: 'stretch',
        }}
        innerStyle={{
          height: '100%',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            fontSize: 24,
            fontWeight: 600,
            color: variant === 'purple' ? theme.palette.common[1] : theme.palette.common[0],
            marginRight: 5,
          }}
        >
          +
        </div>
      </ImageBW>
      <div
        style={{
          position: 'relative',
          height: '100%',
          width: '20vmin',
        }}
      >
        <img
          src={cdnPath.COIN_PACKAGE + item.IMAGE}
          style={{
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
        {item.CORNER_FLAG && (
          <img
            src={assets.upsell[item.CORNER_FLAG] || assets.upsell['amazing']}
            style={{
              position: 'absolute',
              top: -6,
              left: 17,
              right: 17,
              height: 25,
              objectFit: 'contain',
            }}
          />
        )}
      </div>
      <div
        className="stack"
        style={{
          flex: 1,
          textAlign: 'center',
        }}
      >
        <div
          style={{
            ...coinAmountStyle,
            color: item.CORNER_FLAG ? theme.palette.common[0] : theme.palette.common[1],
          }}
        >
          {coinAmount}
        </div>
        {((showPromoBoost && !item.IS_SALE) || (percent > 0 && !item.IS_SALE)) && (
          <div
            style={{
              ...extraStyle,
              color: item.CORNER_FLAG ? theme.palette.common[4] : theme.palette.primary[13],
            }}
          >
            {percent}
            {getText(TEXT_KEY.EXTRA_PERCENTAGE)}
          </div>
        )}
        {!showPromoBoost && item.IS_SALE && (
          <div
            style={{
              ...extraStyle,
              color: item.CORNER_FLAG ? theme.palette.common[0] : theme.palette.common[1],
            }}
          >
            <span style={{ color: theme.palette.secondary[5] }}>{getText(TEXT_KEY.SALE)}!</span> {getText(TEXT_KEY.WAS)}{' '}
            <span style={{ textDecoration: 'line-through' }}>{item.ORIGINAL_AMOUNT}</span>
          </div>
        )}
        {showPromoBoost && item.IS_SALE && (
          <div
            style={{
              ...extraStyle,
              color: item.CORNER_FLAG ? theme.palette.common[4] : theme.palette.primary[13],
            }}
          >
            <span>
              {parseInt(item.PROMO_BOOST_PERCENTAGE) + parseInt(item.SALE_PERCENTAGE)}{' '}
              {getText(TEXT_KEY.EXTRA_PERCENTAGE)}
            </span>
          </div>
        )}
      </div>
      <div
        style={{
          width: '20vmin',
          color: item.CORNER_FLAG ? theme.palette.common[0] : theme.palette.common[1],
          textAlign: 'center',
          paddingRight: 0,
        }}
      >
        <p style={{ fontSize: '1.5rem', margin: 0 }}>${item.PRICE}</p>
      </div>
      <img
        qa-id="coinItemBuyButton"
        src={require(asset`images/Coin_Store_Assets/Buttons/Item_Row_Buy_Button@3x.png`)}
        style={{
          marginRight: '1vmin',
          objectFit: 'contain',
          width: 100,
          pointerEvents: 'all',
          cursor: 'pointer',
        }}
        onClick={() =>
          buyHandle(item.CURRENCY_ITEM_ID, item.NAME, null, item.PRICE, purchaseActionTriggers.STORE_COIN_ITEM)
        }
      />
    </ImageBW>
  );
}

